<template>
    <div style=" padding: 70px; text-align: center; min-height: 300px; vertical-align: middle;"><h1>{{$t('VerificationunderProccess')}}</h1></div>
</template>
<script>
    import GlobalMixin from '@/GlobalMixin.js'
    export default {
        mixins: [GlobalMixin],
        data() {
            return {

            }
        },
        created() {
            let self = this;
            self.ShowLoading();
            let url = process.env.VUE_APP_APIEndPoint + `auth/verify/email/${self.$route.params.id}/`
            self.axios.get(url, self.headers)
                .then(function (res) {
                    if (res.data.success) {
                        self.model = {};
                        self.notify(self.$t('verify success'), "success");
                        self.$router.push({ name: 'Login', params: { id: res.data.data.user.category } });
                    }
                    else {
                        self.notify(self.$t(res.data.Messages[0].Message), "error");
                    }
                })
                .catch(function (err) {
                    self.$router.push({ name: 'Home'});
                    self.displayError(err);
                }).finally(function () {
                    return self.HideLoading();
                })       
        }
    }
</script>